import axios from 'axios';

export function initPopup() {
  // Находим попап и связанные элементы
  const popup = document.getElementById('requestPopup');
  const overlay = popup ? popup.querySelector('.popup__overlay') : null;
  const closeButton = popup ? popup.querySelector('.popup__close') : null;
  const form = popup ? popup.querySelector('form') : null;

  // Находим все кнопки, которые должны открывать попап
  const openButtons = document.querySelectorAll('.open-popup, .cta-button[data-popup="true"], #floatingRequestButton');

  // Функция открытия попапа
  const openPopup = (formId) => {
    if (popup) {
      popup.classList.add('active');
      document.body.style.overflow = 'hidden'; // Блокируем прокрутку
      console.log(formId);
      let goalField = document.getElementById('metrika_goal');
      goalField.value = formId
    }
  };

  // Функция закрытия попапа
  const closePopup = () => {
    if (popup) {
      popup.classList.remove('active');
      document.body.style.overflow = ''; // Разблокируем прокрутку
    }
  };

  // Добавляем обработчики открытия попапа
  if (openButtons.length) {
    openButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        let formId = e.target.getAttribute('data-id')
        openPopup(formId);

        // Если у кнопки есть атрибут data-course, устанавливаем выбор в форме
        const courseType = button.getAttribute('data-course');
        if (courseType && form) {
          const select = form.querySelector('select');
          if (select) {
            // Ищем вариант с нужным значением
            const option = Array.from(select.options).find(opt => opt.value === courseType);
            if (option) {
              option.selected = true;
            }
          }
        }
      });
    });
  }

  // Добавляем обработчики закрытия попапа
  if (overlay) {
    overlay.addEventListener('click', closePopup);
  }

  if (closeButton) {
    closeButton.addEventListener('click', closePopup);
  }

  // Закрытие по Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup && popup.classList.contains('active')) {
      closePopup();
    }
  });

  // Обработка отправки формы в попапе
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      // Проверка на заполненность обязательных полей
      const nameInput = form.querySelector('input[placeholder*="имя" i]');
      const phoneInput = form.querySelector('input[placeholder*="телефон" i]');
      const privacyCheckbox = form.querySelector('.form__privacy-checkbox');

      let isValid = true;

      // Проверка имени
      if (nameInput && nameInput.value.trim() === '') {
        showFormError(nameInput, 'Пожалуйста, введите ваше имя');
        isValid = false;
      } else if (nameInput) {
        hideFormError(nameInput);
      }

      // Проверка телефона
      if (phoneInput && phoneInput.value.trim() === '') {
        showFormError(phoneInput, 'Пожалуйста, введите ваш телефон');
        isValid = false;
      } else if (phoneInput) {
        hideFormError(phoneInput);
      }

      // Проверка согласия
      if (privacyCheckbox && !privacyCheckbox.checked) {
        const privacyLabel = form.querySelector('.form__privacy-label');
        if (privacyLabel) {
          privacyLabel.classList.add('form__privacy-label--error');
        }
        isValid = false;
      } else if (privacyCheckbox) {
        const privacyLabel = form.querySelector('.form__privacy-label');
        if (privacyLabel) {
          privacyLabel.classList.remove('form__privacy-label--error');
        }
      }


      const url = form.getAttribute('action');
      const inputs = form.querySelectorAll('input');
      let dataForm = new FormData();

      dataForm.append("school", document.querySelector('#formSchool').value);

      // Сбор данных и очистка ошибок
      inputs.forEach(input => {
        // const wrapper = input.closest('.form__group');
            // console.log(input.value, input.getAttribute('name'))
            dataForm.append(input.getAttribute('name'), input.value);
      });

      // for (var pair of dataForm.entries()) {
      //     console.log(pair[0]+ ', ' + pair[1]); 
      // }

      //       console.log(inputs, dataForm.getAll, url)
      // return;

      if (isValid) {
        // Имитация отправки формы
        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
          const originalText = submitButton.textContent;
          submitButton.textContent = 'Отправка...';
          submitButton.disabled = true;

          const response = axios.post(url, dataForm, {
          headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Content-Type': 'multipart/form-data',
          },
          transformResponse: (data) => JSON.parse(data),
          responseType: 'text',
          })
          .then((response) => {
            form.reset();

            // Удаляем возможные предыдущие сообщения
            const prevMessage = form.querySelector('.form__message');
            if (prevMessage) {
              prevMessage.remove();
            }

            // Добавляем сообщение об успешной отправке
            const successMessage = document.createElement('div');
            successMessage.className = 'form__message form__message--success';
            successMessage.textContent = 'Спасибо! Ваша заявка отправлена. Мы свяжемся с вами в ближайшее время.';
            form.appendChild(successMessage);

            let metrikaId = document.getElementById('metrika_id').value;
            let formId = document.getElementById('metrika_goal').value;

            // console.log(response.data)
            if (response.data.status == 'ok' || response.data.status == 'success') {
              ym(metrikaId, "reachGoal", 'form_success_sended_'+formId)
              console.log(formId);
              // MicroModal.show('modal-success');
              // $('.js-lk-link').attr('href', 'https://lk.online-london.com/?api_token='+response.data.api_token)
              //   MicroModal.show('modal-success');

                          // Возвращаем исходное состояние кнопки
              submitButton.textContent = originalText;
              submitButton.disabled = false;

                       setTimeout(() => {
              closePopup();

              // Удаляем сообщение после закрытия
              setTimeout(() => {
                if (successMessage.parentNode === form) {
                  successMessage.remove();
                }
              }, 500);
            }, 3000);
              
            } else {
              if (response.data.errors.email) {
                $('input[label="email"]').closest('.uk-margin').find('.uk-form-label').find('span').html(response.data.errors.email)
                $('input[label="email"]').addClass('error');
              } else if (response.data.errors.phone) {
                $('input[label="phone"]').closest('.uk-margin').find('.uk-form-label').find('span').html(response.data.errors.phone)
                $('input[label="phone"]').addClass('error');
              }
            }
            $('.js-confirm').removeAttr('disabled').css('opacity', 1).find('span').html('Записаться');
          });
          
          
          // Имитация задержки отправки
          // setTimeout(() => {
   

       



          //   // Закрываем попап через 3 секунды
   
          // }, 1500);
        }
      }
    });
  }
}

// Функция отображения ошибки формы
function showFormError(input, message) {
  hideFormError(input); // Сначала удаляем предыдущую ошибку, если есть

  input.classList.add('form__input--error');

  const errorMessage = document.createElement('div');
  errorMessage.className = 'form__error';
  errorMessage.textContent = message;

  input.parentNode.appendChild(errorMessage);
}

// Функция скрытия ошибки формы
function hideFormError(input) {
  input.classList.remove('form__input--error');

  const existingError = input.parentNode.querySelector('.form__error');
  if (existingError) {
    existingError.remove();
  }
}
